import { IoCContainer } from '@lmnop/web-core';
import { AngularCoreIoCContainer, AngularCoreIoCKeys } from 'angular-core-src';
import { AngularTranslation } from './angular-core-src/ioc/implementation/angular-translation/angular-translation.class';

//IoCContainer.bind START
IoCContainer.bindSingletonType(AngularCoreIoCKeys.IAngularCoreIoCContainer, AngularCoreIoCContainer);
IoCContainer.bindSingletonType(AngularCoreIoCKeys.IAngularTranslation, AngularTranslation);
//IoCContainer.bind END

export * from './angular-core-src';
